
import { DataType } from "./@types/place-category.d";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import { fetchPlaceCategoryList } from "@/api/adapter.api";
// mixins
import Vue2Filters from "vue2-filters";
import PlaceCategoryMixin2 from "@/mixins/filter-genre.mixin";
// components
import NormalGenre from "@/components/genre-place-category/place-category-normal-genre.vue";
import GenreCategory from "@/components/genre-place-category/place-category-genre-category.vue";
import GenreCategoryBtn from "@/components/genre-place-category/place-category-genre-category-btn.vue";
import { mapMutations, mapState } from "vuex";
import { translateI18n } from "@/util/i18n.helper";

export default PlaceCategoryMixin2.extend({
  name: "component-place-category-body",
  mixins: [Vue2Filters.mixin, PlaceCategoryMixin2],
  components: {
    NormalGenre,
    GenreCategory,
    GenreCategoryBtn,
  },
  data(): DataType {
    return {
      placeCategoryList: undefined,
      genreCategoryList: [],
    };
  },
  computed: {
    ...mapState("data", ["selectedGenre", "selectedCountry"]),
    showList(): boolean {
      return !["evacuation-center", "polling-place"].includes(this.selectedGenre);
    },
    showGenreSelector(): boolean {
      return !["disaster-prevention"].includes(this.selectedGenre);
    },
    hideGenreCategoryButtons(): boolean {
      return (
        this.selectedGenre !== "all" &&
        this.selectedGenre !== "polling-place" &&
        this.selectedGenre !== "evacuation-center"
      );
    },
    showPoll(): boolean {
      if (this.placeCategoryList === undefined) return false;
      const result: number = this.placeCategoryList.findIndex(
        (category: PortalAdapterApi.PlaceCategory) => category.placeCategoryType === "polling-place",
      );
      return result > -1 ? true : false;
    },
    onlyShowInJapan(): boolean {
      // only 1 genre: restaurant in Taiwan
      return this.placeCategoryListLength > 1;
    },
    placeCategoryListLength(): number {
      return this.placeCategoryList !== undefined ? this.placeCategoryList.length : 0;
    },
  },
  watch: {
    selectedGenre(newValue: PortalAdapterApi.PlaceCategoryType, oldValue: PortalAdapterApi.PlaceCategoryType) {
      if (newValue === oldValue) return;
      this.initGenreCategoryList(newValue);
    },
    selectedCountry(newCountry: string, oldCountry: string) {
      if (newCountry === oldCountry) return;
      this.getPlaceCategoryList();
    },
  },
  created() {
    this.getPlaceCategoryList();
    if (
      this.selectedGenre !== undefined &&
      this.selectedGenre !== "all" &&
      this.selectedGenre !== "polling-place" &&
      this.selectedGenre !== "evacuation-center"
    ) {
      this.initGenreCategoryList(this.selectedGenre);
    }
  },
  methods: {
    ...mapMutations("data", ["setSelectedGenreCategoryList", "setGenreList", "setSelectedGenre"]),
    initGenreCategoryList(selectedGenre: PortalAdapterApi.PlaceCategoryType) {
      this.$store
        .dispatch("data/fetchGenreCategoryList", selectedGenre)
        .then((res: PortalAdapterApi.GenreCategoryType) => {
          this.genreCategoryList = [];
          this.genreCategoryList = res;
        })
        .catch(() => console.error("fetchGenreCategoryList error"));
    },
    showDisplayText(i18nObj: PortalAdapterApi.I18nObject): string {
      return translateI18n(i18nObj);
    },
    // ジャンル対するカテコり
    genreCategoryBtnClicked(genreCategory: string) {
      if (this.hasGenreCategory(genreCategory)) {
        const index: number = this.selectedGenreCategoryList.findIndex(
          (category: string) => category === genreCategory,
        );
        if (index >= 0) {
          this.selectedGenreCategoryList.splice(index, 1);
        }
      } else {
        const list = this.selectedGenreCategoryList;
        list.push(genreCategory);
        this.setSelectedGenreCategoryList(list);
      }
    },
    rowClicked(genreType: PortalAdapterApi.PlaceCategoryType) {
      this.setSelectedGenreCategoryList([]);
      // change to use toggle style
      if (!this.selectedGenre || this.selectedGenre === "all") {
        this.setSelectedGenre(genreType);
      } else {
        if (genreType === this.selectedGenre) {
          this.setSelectedGenre(undefined);
        } else {
          this.setSelectedGenre(genreType);
        }
      }
    },
    getPlaceCategoryList() {
      const countryName: string | undefined = this.$store.getters["data/getSelectedCountry"];
      if (countryName === undefined) return;
      fetchPlaceCategoryList(countryName)
        .then((res: PortalAdapterApi.ResponseGetPlaceCategoryList) => {
          this.placeCategoryList = res;
          this.setGenreList(res);
        })
        .catch(() => {
          this.$store.commit("ui/setAlertView", {
            status: true,
            msg: this.$i18n.t("Alert.networkError"),
            btnTitle: this.$i18n.t("Alert.reloadBtn"),
          });
        });
    },
  },
});
